var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMap = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_12a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.9008 14.3956-4.8-1.5954V1.6036l4.8 1.5954zm.8-.0349V3.1293L14.8783 1.65c.395-.183.8225.154.8225.648v9.7291c0 .2848-.15.5406-.3775.6481l-3.6225 1.6825zM1.6783 3.324l3.6225-1.6826V12.87l-3.1775 1.4791c-.395.1831-.8225-.154-.8225-.648V3.972c0-.2848.15-.5405.3775-.648"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_12a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h16v16H.5z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map.74fb98cb00f3240063ca70ef69a35362.svg";